export default {"src":"/_next/static/image/public/images/social_youTube_blue.d90bdafc7230b90339ee7a077c77246d.svg","height":11,"width":17};